<script>
import _ from 'lodash'
import { login } from '../services/userService'

const defaultErrors = { email: null, password: null }

export default {
  name: 'LoginView',
  data() {
    return {
      userForm: {},
      errors: { ...defaultErrors },
      loading: false
    }
  },
  methods: {
    async login() {
      if (!this.validateForm()) return

      login(this.userForm)
        .then(loginData => {
          this.identify(loginData.user)

          this.$store.dispatch('login', loginData)

          this.$router.replace({ name: 'DashboardView' })
        })
        .catch(({ message }) => {
          if (message.includes('Email does not exist'))
            this.errors.email = "We couldn't find an account with this email."
          if (message.includes('Wrong password'))
            this.errors.password = 'The password you entered is incorrect.'
        })
        .finally(() => (this.loading = false))
    },
    identify(user) {
      this.$amplitude.setUserId(user._id)

      const identify = new this.$amplitude.Identify()
        .set('email', user.email)
        .set('first_name', user.firstName)
        .set('last_name', user.lastName)
        .set('birth_date', user.birthDate)
        .set('gender', user.gender)
        .add('logins', 1)

      this.$amplitude.identify(identify)
    },
    validateForm() {
      const errors = {}

      if (this.userForm.email.length === 0)
        errors.email = 'Enter your email address.'
      else if (this.userForm.password.length === 0)
        errors.password = 'Enter your password.'

      this.errors = { ...defaultErrors, ...errors }
      return !_.some(errors)
    }
  }
}
</script>

<template>
  <form class="section container" @submit.prevent="login">
    <div class="columns">
      <div class="column is-offset-3 is-6">
        <div class="illustration is-hidden-mobile">
          <img src="@/assets/img/illustrations/sign-in-2.png" alt="Login" />
        </div>

        <h2 class="title is-3 is-spaced has-text-centered">Welcome back!</h2>

        <div class="subtitle has-text-centered">
          Don't have an account?
          <router-link :to="{ name: 'RegisterView' }">Sign up here</router-link>
        </div>

        <b-field
          :type="{ 'is-danger': !!errors.email }"
          :message="errors.email"
          label="Email"
        >
          <b-input v-model="userForm.email" type="email" placeholder="Email" />
        </b-field>

        <b-field
          :type="{ 'is-danger': !!errors.password }"
          :message="errors.password"
          label="Password"
        >
          <b-input
            v-model="userForm.password"
            type="password"
            placeholder="Password"
            password-reveal
          />
        </b-field>

        <div class="subtitle is-6 has-text-right">
          <router-link :to="{ name: 'ForgotPasswordView' }"
            >Forgot password?</router-link
          >
        </div>

        <div class="column is-pulled-right">
          <button class="button is-rounded is-secondary" type="submit">
            Go to dashboard
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<style lang="sass" scoped>
.is-vertical-center
  align-items: center
  margin-top: 13vw

.field, button, h1
  margin-bottom: 20px

.illustration
  padding: 0 0 25px
  text-align: center
  img
    max-height: 200px
</style>
